// Données complètes pour la gestion des réunions de gouvernance Administration & RH
// Réunion kickoff début d'année avec ordre du jour structuré

export interface Participant {
  id: string;
  nom: string;
  prenom: string;
  role: 'Président' | 'Membre' | 'Invité' | 'Secrétaire';
  email: string;
  avatar?: string;
  present: boolean;
}

export interface OrdreDuJourItem {
  id: string;
  numero: number;
  titre: string;
  description: string;
  dureeMinutes: number;
  responsable: string;
  statut: 'Non traité' | 'En discussion' | 'Complété' | 'Reporté';
}

export interface Note {
  id: string;
  type: 'generale' | 'decision' | 'enjeu' | 'risque';
  contenu: string;
  auteur: string;
  timestamp: string;
}

export interface Action {
  id: string;
  titre: string;
  description: string;
  responsable: string;
  echeance: string;
  priorite: 'Basse' | 'Moyenne' | 'Haute' | 'Critique';
  statut: 'À faire' | 'En cours' | 'Complété' | 'Bloqué';
}

export interface Reunion {
  id: string;
  titre: string;
  date: string; // Format: YYYY-MM-DD
  heure: string; // Format: HH:MM:SS
  dureeMinutes: number;
  lieu: string;
  objectifPrincipal: string;
  statut: 'Planifiée' | 'En cours' | 'Complétée';
  participants: Participant[];
  ordreDuJour: OrdreDuJourItem[];
  notes: Note[];
  actions: Action[];
  resumeGenere: boolean;
  resumeContenu?: string;
  verbatim?: string;
}

// ============================================
// PARTICIPANTS RÉCURRENTS - ADMINISTRATION & RH
// ============================================

const participantsRecurrents: Participant[] = [
  {
    id: 'p1',
    nom: 'Delisle',
    prenom: 'François',
    role: 'Président',
    email: 'fdelisle@bzinc.ca',
    avatar: '/FP.png',
    present: true
  },
  {
    id: 'p2',
    nom: 'Pelletier',
    prenom: 'Mélissa',
    role: 'Membre',
    email: 'mpelletier@bzinc.ca',
    avatar: '/MP.png',
    present: true
  },
  {
    id: 'p3',
    nom: 'Quintal',
    prenom: 'LAH',
    role: 'Membre',
    email: 'equal@bzinc.ca',
    avatar: '/LAH.jpg',
    present: true
  },
  {
    id: 'p4',
    nom: 'Delisle',
    prenom: 'Richard',
    role: 'Membre',
    email: 'rdelisle@bzinc.ca',
    avatar: '/RD.png',
    present: true
  },
  {
    id: 'p5',
    nom: 'Bourassa',
    prenom: 'Dany',
    role: 'Membre',
    email: 'dbourassa@bzinc.ca',
    avatar: '/DB.png',
    present: true
  },
  {
    id: 'p6',
    nom: 'Dany',
    prenom: 'Dany',
    role: 'Membre',
    email: 'yannick@bzinc.ca',
    avatar: '/DB.png',
    present: true
  }
];

// ============================================
// RÉUNION #1 - KICKOFF DÉBUT D'ANNÉE
// ============================================

export const reunionKickoff: Reunion = {
  id: 'reunion-kickoff-2025',
  titre: '🧭 Réunion de gouvernance – Administration & RH',
  date: '2025-01-15',
  heure: '10:00:00',
  dureeMinutes: 95,
  lieu: 'Salle de conférence principale - BZ Inc.',
  objectifPrincipal: 'Kickoff début d\'année : clarifier les rôles et responsabilités, assurer le respect des cadres et procédures, documenter les décisions structurantes, maintenir une gouvernance continue et cohérente.',
  statut: 'Complétée',
  participants: participantsRecurrents.map(p => ({ ...p, present: true })),
  
  ordreDuJour: [
    {
      id: 'kickoff-odj-1',
      numero: 1,
      titre: 'Présentation du cadre de gouvernance Administration & RH',
      description: 'Revue du RACI officiel, clarification des rôles et responsabilités pour gouvernance, finance, RH, opérations administratives et outils.',
      dureeMinutes: 20,
      responsable: 'François Delisle',
      statut: 'Complété'
    },
    {
      id: 'kickoff-odj-2',
      numero: 2,
      titre: 'Cadres & politiques – Conformité globale',
      description: 'Validation des cadres existants, identification des écarts, plan de remédiation pour assurer conformité complète.',
      dureeMinutes: 15,
      responsable: 'François Delisle',
      statut: 'Complété'
    },
    {
      id: 'kickoff-odj-3',
      numero: 3,
      titre: 'Finance & Comptabilité – Discipline financière',
      description: 'Revue des processus de fermeture de mois, paie, états financiers, amortissements. Validation de la discipline financière.',
      dureeMinutes: 20,
      responsable: 'Mélissa Pelletier',
      statut: 'Complété'
    },
    {
      id: 'kickoff-odj-4',
      numero: 4,
      titre: 'Opérations administratives & Recevables',
      description: 'Optimisation des flux admin quotidiens, application des procédures, documentation opérationnelle. Focus sur recevables.',
      dureeMinutes: 15,
      responsable: 'Louis-Alexandre Hébert',
      statut: 'Complété'
    },
    {
      id: 'kickoff-odj-5',
      numero: 5,
      titre: 'RH & Dossiers employés – Cadres RH & conformité',
      description: 'Revue des cadres RH, processus d\'onboarding, gestion des dossiers employés, plaintes & incidents, PRIsME Employé. Dany (Accountable) impose les cadres à instaurer au niveau opération RH. Mélissa et LAH se partagent les gestions aux quotidiens (Responsible). Dany est A/R pour PRIsME Employé.',
      dureeMinutes: 15,
      responsable: 'Dany',
      statut: 'Complété'
    },
    {
      id: 'kickoff-odj-6',
      numero: 6,
      titre: 'Licences & Contrats – Gestion et contrôle',
      description: 'Gestion des licences Microsoft 365, contrôle des licences, rapports quotidiens, validation, logistique. Gestion des contrats, contrôle et rapports.',
      dureeMinutes: 15,
      responsable: 'Richard Delisle',
      statut: 'Complété'
    },
    {
      id: 'kickoff-odj-7',
      numero: 7,
      titre: 'Outils & Systèmes – Adoption et évolution',
      description: 'Cadres d\'utilisation des outils, adoption, évolution des outils, innovation & AI, centralisation des données.',
      dureeMinutes: 5,
      responsable: 'Dany Bourassa',
      statut: 'Complété'
    }
  ],
  
  notes: [
    {
      id: 'kickoff-note-1',
      type: 'decision',
      contenu: 'DÉCISION: Le RACI officiel Administration & RH est validé et devient la référence unique pour toutes les décisions et responsabilisations. PRIsME est la source de vérité officielle.',
      auteur: 'François Delisle',
      timestamp: '2025-01-15T10:05:00'
    },
    {
      id: 'kickoff-note-2',
      type: 'generale',
      contenu: 'Principe fondamental rappelé : Un seul A (Accountable) par sujet. Si ce n\'est pas clair qui est Accountable, ce n\'est pas gouverné.',
      auteur: 'François Delisle',
      timestamp: '2025-01-15T10:10:00'
    },
    {
      id: 'kickoff-note-3',
      type: 'decision',
      contenu: 'DÉCISION: Plan de remédiation conformité - 5 cadres à mettre à jour d\'ici Q2 2025. François responsable, LAH exécute.',
      auteur: 'François Delisle',
      timestamp: '2025-01-15T10:25:00'
    },
    {
      id: 'kickoff-note-4',
      type: 'generale',
      contenu: 'Finance : Discipline financière excellente. Processus de fermeture de mois optimisés. Mélissa confirme que tous les contrôles sont en place.',
      auteur: 'Mélissa Pelletier',
      timestamp: '2025-01-15T10:45:00'
    },
    {
      id: 'kickoff-note-5',
      type: 'enjeu',
      contenu: 'ENJEU: Recevables - amélioration continue nécessaire sur les relances structurées. LAH propose nouveau processus automatisé.',
      auteur: 'Louis-Alexandre Hébert',
      timestamp: '2025-01-15T11:00:00'
    },
    {
      id: 'kickoff-note-6',
      type: 'decision',
      contenu: 'DÉCISION: Nouveau processus recevables approuvé. Budget 15k$ pour automatisation. LAH responsable livraison Q2.',
      auteur: 'François Delisle',
      timestamp: '2025-01-15T11:05:00'
    },
    {
      id: 'kickoff-note-7',
      type: 'generale',
      contenu: 'RH : Dany (Accountable) impose les cadres RH à instaurer au niveau opérationnel. Mélissa et LAH se partagent les gestions aux quotidiens (Responsible). Onboarding structuré en place. Dossiers employés centralisés dans PRIsME. Processus plaintes & incidents documenté. Dany est A/R pour PRIsME Employé.',
      auteur: 'Dany',
      timestamp: '2025-01-15T11:20:00'
    },
    {
      id: 'kickoff-note-8',
      type: 'generale',
      contenu: 'Licences & Contrats : Richard confirme que la logistique Microsoft 365 est bien structurée. Rapports quotidiens en place. LAH gère les opérations quotidiennes efficacement.',
      auteur: 'Richard Delisle',
      timestamp: '2025-01-15T11:25:00'
    },
    {
      id: 'kickoff-note-9',
      type: 'decision',
      contenu: 'DÉCISION: Processus de validation des rapports licences quotidien approuvé. Richard Accountable, LAH Responsible pour l\'exécution.',
      auteur: 'François Delisle',
      timestamp: '2025-01-15T11:30:00'
    },
    {
      id: 'kickoff-note-10',
      type: 'generale',
      contenu: 'Outils : Adoption PRIsME excellente. Innovation AI en cours. Dany présente roadmap outils Q1-Q2.',
      auteur: 'Dany Bourassa',
      timestamp: '2025-01-15T11:35:00'
    }
  ],
  
  actions: [
    {
      id: 'kickoff-action-1',
      titre: 'Mettre à jour 5 cadres conformité',
      description: 'Révision et mise à jour des cadres identifiés selon plan remédiation',
      responsable: 'Louis-Alexandre Hébert',
      echeance: '2025-04-30',
      priorite: 'Haute',
      statut: 'En cours'
    },
    {
      id: 'kickoff-action-2',
      titre: 'Implémenter nouveau processus recevables automatisé',
      description: 'Développement et déploiement du système de relances structurées automatisées',
      responsable: 'Louis-Alexandre Hébert',
      echeance: '2025-06-30',
      priorite: 'Haute',
      statut: 'À faire'
    },
    {
      id: 'kickoff-action-3',
      titre: 'Documenter processus plaintes & incidents RH',
      description: 'Finaliser documentation complète du processus de gestion des plaintes et incidents RH (Dany Accountable, LAH Responsible)',
      responsable: 'Louis-Alexandre Hébert',
      echeance: '2025-02-28',
      priorite: 'Moyenne',
      statut: 'En cours'
    },
    {
      id: 'kickoff-action-4',
      titre: 'Communiquer RACI officiel à toute l\'organisation',
      description: 'Présentation du RACI Administration & RH lors du Town Hall, documentation accessible dans PRIsME',
      responsable: 'François Delisle',
      echeance: '2025-02-15',
      priorite: 'Haute',
      statut: 'Complété'
    }
  ],
  
  resumeGenere: true,
  resumeContenu: `**RÉSUMÉ PROFESSIONNEL - RÉUNION DE GOUVERNANCE ADMINISTRATION & RH**

**Date:** 15 janvier 2025 | **Durée:** 1h35 | **Participants:** 5 personnes

**CONTEXTE ET OBJECTIFS**
Réunion kickoff début d'année pour structurer la gouvernance du département Administration & RH. Objectif : clarifier les rôles et responsabilités, assurer le respect des cadres et procédures, documenter les décisions structurantes, maintenir une gouvernance continue et cohérente.

**DÉCISIONS MAJEURES**

1. **RACI Officiel Validé**
   - Décidé par : François Delisle (Président)
   - Le RACI Administration & RH devient la référence unique pour toutes les décisions et responsabilisations
   - PRIsME est la source de vérité officielle
   - Principe fondamental : Un seul A (Accountable) par sujet

2. **Plan Remédiation Conformité**
   - Décidé par : François Delisle
   - 5 cadres à mettre à jour d'ici Q2 2025
   - Responsable : François Delisle
   - Exécution : Louis-Alexandre Hébert

3. **Nouveau Processus Recevables Automatisé**
   - Décidé par : François Delisle sur proposition Louis-Alexandre Hébert
   - Budget alloué : 15k$
   - Responsable livraison : Louis-Alexandre Hébert
   - Échéance : Q2 2025

4. **Processus Validation Rapports Licences Quotidiens**
   - Décidé par : François Delisle
   - Richard Delisle : Accountable (contrôle et validation)
   - Louis-Alexandre Hébert : Responsible (exécution opérationnelle)
   - Logistique Microsoft 365 structurée, rapports quotidiens en place

**ENJEUX ET RISQUES IDENTIFIÉS**

✅ **POINTS FORTS**
- Discipline financière excellente (Mélissa)
- Processus de fermeture de mois optimisés
- Onboarding structuré en place
- Adoption PRIsME excellente

⚠️ **ENJEU - Recevables**
- Amélioration continue nécessaire sur les relances structurées
- Nouveau processus automatisé approuvé pour résoudre

**ACTIONS DÉCIDÉES**

| Action | Responsable | Échéance | Priorité |
|--------|-------------|----------|----------|
| Mettre à jour 5 cadres conformité | Louis-Alexandre Hébert | 30 avril 2025 | Haute |
| Implémenter nouveau processus recevables | Louis-Alexandre Hébert | 30 juin 2025 | Haute |
| Documenter processus plaintes & incidents RH (Dany A, LAH R) | Louis-Alexandre Hébert | 28 février 2025 | Moyenne |
| Communiquer RACI officiel à l'organisation | François Delisle | 15 février 2025 | Haute |

**LICENCES & CONTRATS**
- Logistique Microsoft 365 bien structurée (Richard Delisle)
- Rapports quotidiens en place et validés
- LAH gère les opérations quotidiennes efficacement
- Processus de validation quotidien approuvé

**PROCHAINES ÉTAPES**
- Prochaine réunion : À planifier (trimestrielle recommandée)
- Suivi : Avancement remédiation conformité, déploiement processus recevables
- Communication : Town Hall février pour présenter RACI officiel

**GOUVERNANCE**
Cette réunion établit les fondations de la gouvernance Administration & RH. Le RACI officiel est maintenant la référence unique pour toutes les décisions et responsabilisations. PRIsME devient la source de vérité officielle.

---
*Résumé généré par IA PRIsME • Validé par François Delisle • Conforme cadre gouvernance Administration & RH*`,
  
  verbatim: `[10:00] François Delisle : Bonjour à tous, bienvenue à notre première réunion de gouvernance Administration & RH de l'année. L'objectif aujourd'hui est de clarifier nos rôles et responsabilités, assurer le respect des cadres et procédures, et documenter nos décisions structurantes.

[10:05] François : Commençons par le RACI officiel. Ce document définit clairement et officiellement les rôles et responsabilités en gouvernance, finance, RH, opérations administratives et outils. Il sert de référence unique, base de responsabilisation, et point d'ancrage pour les décisions et audits.

[10:10] François : Principe fondamental : Un seul A (Accountable) par sujet. Si ce n'est pas clair qui est Accountable, ce n'est pas gouverné. C'est la règle d'or.

[10:15] Mélissa Pelletier : Je confirme François. Pour la finance, je suis Accountable sur les états financiers, et je suis Responsible sur la fermeture de mois et la paie. LAH exécute avec moi.

[10:20] Louis-Alexandre Hébert : Oui Mélissa. Pour les opérations administratives, je suis Accountable sur les recevables, les flux admin quotidiens, l'application des procédures et la documentation opérationnelle.

[10:25] François : Parfait. Passons à la conformité. On a identifié 5 cadres à mettre à jour d'ici Q2. LAH, tu peux exécuter?

[10:30] LAH : Absolument François. Je vais créer le plan de remédiation et commencer la mise à jour.

[10:35] François : Décision : Plan de remédiation conformité approuvé. François responsable, LAH exécute. Échéance Q2.

[10:45] Mélissa : Pour la finance, tout est en ordre. Discipline financière excellente, processus de fermeture de mois optimisés. Tous les contrôles sont en place.

[11:00] LAH : Un point sur les recevables. J'aimerais proposer un nouveau processus automatisé pour les relances structurées. Budget estimé 15k$.

[11:05] François : Excellente idée LAH. Décision : Nouveau processus recevables approuvé. Budget 15k$. LAH responsable livraison Q2.

[11:20] Dany : Pour RH, je suis Accountable pour les cadres RH et la gestion à haut niveau. J'impose les cadres à instaurer au niveau opérationnel. Mélissa et LAH se partagent les gestions aux quotidiens (Responsible). L'onboarding est structuré, les dossiers employés sont centralisés dans PRIsME, et le processus plaintes & incidents est documenté. Dany est A/R pour PRIsME Employé.

[11:25] Dany Bourassa : Pour les outils, l'adoption PRIsME est excellente. L'innovation AI est en cours. Je vous présente la roadmap outils Q1-Q2.

[11:25] Richard Delisle : Pour les licences et contrats, la logistique Microsoft 365 est bien structurée. Les rapports quotidiens sont en place. LAH gère les opérations quotidiennes efficacement.

[11:30] François : Excellent Richard. Décision : Processus de validation des rapports licences quotidien approuvé. Richard Accountable, LAH Responsible pour l'exécution.

[11:35] Dany : Pour les outils, l'adoption PRIsME est excellente. L'innovation AI est en cours. Je vous présente la roadmap outils Q1-Q2.

[11:40] François : Parfait. Dernière action : je vais communiquer le RACI officiel à toute l'organisation lors du Town Hall de février. PRIsME sera la source de vérité officielle.

[11:40] François : Merci à tous. Prochaine réunion trimestrielle à planifier. Excellente gouvernance!`
};

// ============================================
// EXPORT TOUTES LES RÉUNIONS
// ============================================

export const toutesLesReunionsAdminRH: Reunion[] = [
  reunionKickoff
];

// Fonction pour générer un résumé IA (similaire à Comité TI)
export function genererResumeIA(reunion: Reunion): string {
  // Cette fonction peut être étendue pour utiliser l'IA réelle
  // Pour l'instant, retourne le résumé existant si disponible
  if (reunion.resumeContenu) {
    return reunion.resumeContenu;
  }
  
  // Sinon, génère un résumé basique
  return `**RÉSUMÉ - ${reunion.titre}**

**Date:** ${new Date(reunion.date).toLocaleDateString('fr-FR')} | **Durée:** ${reunion.dureeMinutes} min

**OBJECTIF**
${reunion.objectifPrincipal}

**PARTICIPANTS**
${reunion.participants.filter(p => p.present).map(p => `- ${p.prenom} ${p.nom} (${p.role})`).join('\n')}

**DÉCISIONS**
${reunion.notes.filter(n => n.type === 'decision').map(n => `- ${n.contenu}`).join('\n')}

**ACTIONS**
${reunion.actions.map(a => `- ${a.titre} (${a.responsable}, ${a.echeance})`).join('\n')}

---
*Résumé généré par IA PRIsME*`;
}
